import React, { useEffect } from "react";
import "./ServiceType.scss";

import { useParams } from "react-router-dom";

const SERVICES = [
  {
    id: "SOFTWARE_DEVELOPMENT",
    type: "software-development",
    img: "../software_development2.jpeg",
    title: "Software Development",
    mainParagraph: [
      {
        id: "par1",
        text: "Software product development helps create commercially viable software for corporate clients or  consumers. Workoza provides outsourced product development services to create user-friendly and beautiful software solutions. ",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "Workoza offers full-cycle software development services that seamlessly adapt  to  project goals and business needs, from IT strategy consulting and complete technology roadmaps to building scalable solutions end-to-end. ",
      },
      {
        id: "par2",
        text: "When we outsource software development, we shift  all or part of the software development responsibility to the vendor. We fill gaps in in-house resources and experience to support your company's expansion and digital transformation goals. ",
      },
      {
        id: "par3",
        text: "Application Support and Maintenance Services are designed to make all types of applications  accessible, reliable, and responsive to your ever-changing business needs. Workoza provides full-service IT maintenance and support to customers in various industries. ",
      },
    ],
  },
  {
    id: "PROJECT_MANAGEMENT",
    type: "project-management",
    img: `../project_management2.jpeg`,
    imgAlt: "Project management",
    title: "Project Management",
    mainParagraph: [
      {
        id: "par1",
        text: "Workoza is a boutique IT service provider offering a full range of IT services and solutions. We provide a full range of IT project implementation services for large, medium and small businesses.",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "At Workoza, we take great pride in helping our customers find the IT solutions that best fit their business needs. We work very closely with our clients to implement and adapt their IT projects on time and within budget. Our consultants have extensive experience and industry expertise in executing projects for both large, medium and small businesses.",
      },
      {
        id: "par2",
        text: "A team of highly qualified IT consultants ensures value-added, high-quality and cost-effective project implementation. Workoza project implementations are conducted using best practices, adoption of industry standards, and effective integration of process, people and technology. This approach significantly reduces schedules and overall project costs while delivering feature richness and increasing business value. We believe that the success of your project is the success of Workoza.",
      },
      {
        id: "par3",
        text: "We offer a wide range of project execution services, from scoping, project planning, business conception, solution design, implementation, go-live training and post-go-live support. We also offer technical and functional upgrade services to keep your IT landscape up to date.",
      },
      {
        id: "par4",
        text: "Based in the US, Canada and India, our team of IT professionals offers complete flexibility and expertise to ensure your IT project implementation is high quality yet highly cost effective . We can also customize the implementation model and combine onsite, nearsite, and offsite services according to your requirements.",
      },
    ],
  },
  {
    id: "QUALITY_ASSURANCE",
    type: "quality-assurance",
    img: "../quality_assurance2.jpeg",
    title: "Quality Assurance",
    mainParagraph: [
      {
        id: "par1",
        text: "Our Subject Matter Experts would be glad to help you for any quality assurance tasks you may have. You can have access to our pool of IT professionals when and where you need them.",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "Worokza's QS Recruitment and Staffing services move this tedious process from busy hands to the smart and competent of us. Designed with busy professionals like you in mind, our experienced senior QA experts will help you find, screen, and interview roles from entry-level testers to senior QA executives.",
      },
      {
        id: "par2",
        text: "Demand for this service will be high among small businesses building QA teams. Often such companies require the help of independent experts in searching, selecting, screening and interviewing to select the right people for their teams and organisations. Demand is almost as high as a large recruitment agency with executive positions.",
      },
      {
        id: "par3",
        text: "Just contact us and we will arrange for the right resource to ensure your quality assurance tasks are completed smoothly and effectively.",
      },
    ],
  },
  {
    id: "DATA_ANALYST",
    type: "data-analyst",
    img: "../data_analyst2.jpeg",
    title: "Data & Analytics",
    mainParagraph: [
      {
        id: "par1",
        text: "Data and analytics help businesses improve their operations and digital reach by personalizing customer experiences, refining product strategies and optimizing decision-making. Together we can extract value and opportunity from your growing data.",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "Workoza, a data analytics company, helps multi-sectoral organizations integrate, aggregate and analyze disparate types of data from multiple data sources to meet their most strategic departmental and enterprise-level needs.",
      },
      {
        id: "par2",
        text: "We are data lifecycle experts, letting your data speak for itself through our data analytics services and solutions.",
      },
      {
        id: "par3",
        text: "We leverage data visualization, business analytics, artificial intelligence, machine learning, deep learning, and an integrated data platform to develop business intelligence projects using an integrated approach to implementing business intelligence projects. A leading data and analytics company that helps add value to  your business.",
      },
    ],
  },
  {
    id: "OUR_COMPANY",
    type: "our-company",
    img: "../our_company.jpeg",
    title: "Our Company",
    mainParagraph: [
      {
        id: "par1",
        text: "Workoza is a boutique IT service provider offering a full range of IT services and solutions. We pride ourselves on providing superior IT consulting services to large, medium and small businesses.",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "Workoza was founded by a team of respected IT professionals. We bring the expertise and leadership skills to deliver successful IT projects and help organizations reach their goals. Whether it's a comprehensive IT project, application management services or a short onsite consultation, our solutions are designed to improve the efficiency and productivity of your systems, processes and people. We provide IT services to customers of all sizes, from small businesses to large enterprises.",
      },
      {
        id: "par2",
        text: "We are a no-nonsense, one-stop-shop for IT application expertise from A to Z. Our IT professionals have an average of 10+ years of experience executing multiple IT projects in North America, Europe and Asia. Our consultants are highly skilled professionals with extensive business experience and strong communication skills who fully understand your business requirements and are able to tailor IT solutions to your specific needs.",
      },
      {
        id: "par3",
        text: "Based in the US, Canada and India, our team of experts offers complete flexibility and expertise to ensure that your IT project implementation is of high quality yet highly cost effective. Depending on your requirements, we can customize the implementation model to combine onsite, near site, and offsite services.",
      },
      {
        id: "par4",
        text: "We have built our success on a business philosophy of providing superior customer service, setting ourselves apart from the finished product, and enabling new and returning customers to experience excellence. Our goal is to build a long-term relationship with each customer through collaboration and excellent service.",
      },
      {
        id: "par5",
        text: "We firmly believe that your success is our responsibility.",
      },
    ],
  },
];

const ServiceType = () => {
  const { type } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [type]);

  const selectedService = SERVICES.find(({ type: serviceType }) => {
    return type === serviceType;
  });

  const { title, img, imgAlt, mainParagraph, paragraphs } =
    selectedService || {};

  const renderServiceTypeParagraph = ({ paragraphs }) => {
    return paragraphs.map(({ id, text }) => {
      return <div className="serviceTypeParagraphWrapper">{text}</div>;
    });
  };

  return (
    <div className="serviceTypeContainer">
      <div className="serviceTypeWrapper">
        <div className="serviceTypeHeaderText">{title}</div>
        <div className="serviceTypeParagraphContainer">
          {renderServiceTypeParagraph({ paragraphs: mainParagraph })}
        </div>
        <div className="serviceTypeImgContainer">
          <div className="serviceTypeImgWrapper">
            <img src={img} alt={imgAlt} />
          </div>
        </div>
        <div className="serviceTypeParagraphContainer">
          {renderServiceTypeParagraph({ paragraphs })}
        </div>
      </div>
    </div>
  );
};

export default ServiceType;
